// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__4dnXk","footer":"ReportModalFilter_footer__2Yx8r"};